export default {
  'header': {
    'registrationLogin': 'Registration \\ Login',
    'login': 'Login',
    'profile': 'Profile',
    'historyOfTournaments': 'History of tournaments',
    'subscriptionDepositWithdrawal': 'Subscription / deposit / withdrawal . exchange',
    'transactionHistory': 'Transaction history',
    'logOutOfYourAccount': 'Log out of your account',
    'referralProgramSocialNetworks': 'REFERRAL PROGRAM / Social networks'
  },
  'button': {
    'createTournament': 'Create tournament',
    'create': 'Create'
  },
  'auth': {
    'logIn': 'Login',
    'register': 'Registration',
    'login': 'Email*',
    'password': 'Password*',
    'rememberMe': 'Remember me',
    'forgotYourPassword': 'Forgot your password?',
    'repeatPassword': 'Repeat password*',
    'email': 'Mail*',
    'month': 'Month',
    'day': 'Day',
    'year': 'Year',
    'signUp': 'Sign up',
    'youMustBeToRegister': 'You must be 13+ to register*',
    'successRegister': 'An email was sent to {mail} with instructions on how to activate your account',
    'successfulLogout': 'Successful logout',
    'confirmationTextMessageWasSentToYourEmail': 'A confirmation text message was sent to your email',
    'congratulations': 'CONGRATULATIONS',
    'congratsText': 'with successful registration to Cyber Fight Tournaments! \r\n To enjoy all the benefits of our portal, we recommend that you connect your game accounts in your personal cabinet.',
    'sendCode': 'Send code',
    'checkYourEmail': 'Check your E-mail',
    'changePassword': 'Change password'
  },
  'general': {
    'noMatch': 'no matching options',
    'success': 'Operation is successful',
    'error': 'Error',
    'warning': 'Warning',
    'great': 'Great',
    'gotIt': 'Got it',
    'more': 'More info',
    'join': 'Join',
    'save': 'Save',
    'pageNotFound': 'Oops... page not found',
    'change': 'Change'
  },
  'errors': {
    'required': 'Required to fill out',
    'emailError': 'Invalid email format',
    'numeric': 'Invalid format',
    'notEqualPasswords': 'Passwords don\'t match',
    'minLength': 'Min length {n}',
    'maxLength': 'Max length {n}',
    'isUsername': 'Allowed characters a-z, A-Z, 0-9, _',
    'minValue': 'Min {n}',
    'maxValue': 'Max {n}'
  },
  'mainPage': {
    'gameChoice': 'Game Choice',
    'selectPlatform': 'Selecting the platform',
    'noTournaments': 'Oops... There are no tournaments right now.',
    'tournamentName': 'Tournament name',
    'numberOfPlayers': 'Number of players (max {max})',
    'indiv': 'Solo',
    'team': 'Team',
    'ticket': 'Ticket*',
    'dateAndTime': 'Date and time*',
    'hour': 'Hour',
    'minute': 'Minute',
    'prizeFund': 'Prize fund',
    'currentPrizeFund': 'Current prize fund',
    'maximumPrizeFund': 'Maximum Prize Fund',
    'maximumPrizeFund*': 'Maximum Prize Fund*',
    'free': 'Free',
    'prem': 'Premium',
    'notSelected': 'Not selected',
    'description': 'Tournament description'
  },
  'tournament': {
    'name': 'Name',
    'platform': 'Platform',
    'time': 'days | {n} day | {n} days',
    'youAreInvolvedIn': 'You are involved in',
    'ticket': 'Ticket',
    'awards': 'Awards',
    'completed': 'Completed',
    'youTookPartInTournament': 'You took part in a tournament',
    'connectionOptions': 'Connection options',
    'howToConnect': 'How to connect?',
    'tournamentDescription': 'Tournament description',
    'participants': 'Participants',
    'from': 'from',
    'positionInTable': 'Position in table',
    'chooseWinnerOrLoser': 'Choose whether you are a winner or a loser, and upload a screenshot of the tournament summary table for moderation.',
    'winner': 'Winner',
    'loser': 'Loser',
    'downloadScreenshotOfTheSummaryTable': 'Download a screenshot of the summary table',
    'review': 'Review',
    'seatAllocation': 'Seat allocation',
    'place': '({n} place)',
    'listOfParticipantsEmpty': 'The list of participants is empty',
    'listOfAwardsEmpty': 'The list of awards is empty'
  },
  'profile': {
    'edit': 'Редактировать профиль',
    'changeAvatar': 'Сменить аватар',
    'randomAvatar': 'Рандомный аватар',
    'matches': 'Сыграно матчей',
    'wins': 'Одержано побед',
    'referrals': 'Рефералов',
    'nickname': 'Никнейм*',
    'email': 'Почта*',
    'exchange': 'Exchange',
    'changeEmail': 'Сменить почту',
    'changePassword': 'Смена пароля',
    'currentPassword': 'Текущий пароль*',
    'newPassword': 'Новый пароль*',
    'repeatPassword': 'Повторите новый пароль*',
    'nicknames': 'Никнеймы в играх',
    'save': 'Сохранить изменения',
    'idTransaction': 'ID transaction',
    'transactionType': 'Transaction type',
    'transactionDate': 'Transaction Date',
    'currency': 'Currency',
    'linkSuccessfullyCopied': 'link successfully copied',
    'noTournamentsFound': 'No tournaments found',
    'noTransactionsFound': 'No transactions found',
    'toPayFollowThisLink': 'To pay, follow this link',
    'dataUpdatedSuccessfully': 'Data updated successfully',
    'idSearch': 'Tournament ID',
    'forExchange': 'For exchange:',
    'total': 'Total:'
  },
  'transactions': {
    'transactionsPerPage': 'Transactions per page',
    'buy_in': 'Buy in',
    't_creation': 'Tournament Creation',
    't_participation': 'Tournament Participation',
    't_prize': 'Tournament prize',
    't_refund': 'Tournament refund',
    'withdrawal': 'Withdrawal',
    'withdrawal_refund': 'Withdrawal refund',
    'deposit_wait': 'Deposit wait',
    'deposit': 'Deposit',
    'deposit_bonus': 'Deposit bonus',
    'admin_change': 'Admin change',
    'user_change': 'Change'
  }
}



// WEBPACK FOOTER //
// ./src/locales/en.js